import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Container, Typography, Box, Avatar, Grid, Card, CardContent, CardActions, Button, Paper } from '@mui/material';
import { Link } from 'react-router-dom';

const ProfilePage = () => {
  const { user } = useAuth();

  if (!user) {
    return (
      <Container sx={{ mt: 4 }}>
        <Typography variant="h6">
          You must be logged in to view this page.
        </Typography>
      </Container>
    );
  }

  const { name, email, picture } = user;

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Grid container spacing={4} direction="column" alignItems="center">
        {/* Profile Card */}
        <Grid item xs={12} sm={10} md={8}>
          <Paper elevation={3} sx={{ mt: 4, p: 4 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Avatar src={picture} sx={{ width: 90, height: 90, mb: 2 }}>
                {name ? name.charAt(0).toUpperCase() : 'U'}
              </Avatar>
              <Typography variant="h4" component="h1" gutterBottom>
                {name || 'User Profile'}
              </Typography>
              <Typography variant="body1" color="text.secondary">
                {email}
              </Typography>
            </Box>
          </Paper>
        </Grid>

        {/* Workflows Card */}
        <Grid item xs={12} sm={10} md={8}>
          <Card>
            <CardContent>
              <Typography variant="h5" component="h2">
                Workflows
              </Typography>
              <Typography variant="body2" color="text.secondary">
                View your assigned workflows.
              </Typography>
            </CardContent>
            <CardActions>
              <Button component={Link} to="/workflows" size="small">View Workflows</Button>
            </CardActions>
          </Card>
        </Grid>

        {/* Payments Card */}
        <Grid item xs={12} sm={10} md={8}>
          <Card>
            <CardContent>
              <Typography variant="h5" component="h2">
                Payments
              </Typography>
              <Typography variant="body2" color="text.secondary">
                View your payment methods.
              </Typography>
            </CardContent>
            <CardActions>
              <Button component={Link} to="/payments" size="small">View Payments</Button>
            </CardActions>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default ProfilePage;
